/* eslint no-restricted-syntax: "off" */
import { Spin, Table } from "antd";
import * as React from "react";
import { apiLoadPersonList } from "src/common/apiPerson";
import { loadAttrTypeMap } from "src/common/attributes";
import { makeAttrLabel } from "src/common/attributes/makeAttrLabel/makeAttrLabel";
import { getAllLabelDataAttributes } from "src/common/attributes/makeAttrLabel/utils/getAllLabelDataAttributes";
import { onError } from "src/common/onError";
import { AColumn } from "src/components/tables/AsyncTable";
import { ZAttribute } from "src/types/ZAttribute";
import { ZPersonEntity } from "src/types/ZPersonEntity";
import { AttrData } from "../AttributeHistrory.types";

const groupAttrsByName = (arr: ZAttribute[]): Record<string, ZAttribute[]> =>
  arr.reduce(
    (acc, attr) => ({
      ...acc,
      [attr.name]: [...(acc[attr.name] ?? []), attr],
    }),
    {} as ReturnType<typeof groupAttrsByName>,
  );

export const AttrUsersList: React.FC<AttrData> = ({ value, objectId }) => {
  const [loading, setLoading] = React.useState(false);
  const [columns, setColumns] = React.useState<AColumn<ZPersonEntity>[]>([]);
  const [users, setUsers] = React.useState<ZPersonEntity[]>([]);

  const setColumnsFromTreeData = (
    allAttrs: ZAttribute[],
    typesMap: Record<string, string>,
  ) => {
    const groups = groupAttrsByName(allAttrs);
    const columnsList = Object.entries(groups).map(([name, attrs]) => ({
      key: name,
      dataIndex: name,
      title: name,
      render(_: string[], row: ZPersonEntity) {
        const attribute = attrs.find((attr) =>
          row.attributeValues.map((v) => v.attributeId).includes(attr.id),
        );
        if (!attribute) {
          return null;
        }
        return makeAttrLabel({
          attribute,
          attributeList: getAllLabelDataAttributes(row.labelData?.attributes),
          labelTreeData: row.labelData?.labels || [],
          typesMap,
        });
      },
    }));
    columnsList.sort((a, b) => (a.title > b.title ? 1 : -1));
    setColumns(columnsList);
  };

  const init = async () => {
    setLoading(true);
    try {
      const data = await apiLoadPersonList(
        {
          objectId,
          roleIds: [],
          userIds: value.split(","),
        },
        { withLabels: true },
      );

      const allAttrs = getAllLabelDataAttributes(data.attributesLabels);
      const typesMap = await loadAttrTypeMap();
      setColumnsFromTreeData(allAttrs, typesMap);
      setUsers(data.content);
    } catch (e) {
      onError(e);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    init();
  }, []);

  return loading ? (
    <Spin spinning={loading}>...</Spin>
  ) : (
    <Table
      style={{ marginTop: 8 }}
      key="id"
      size="small"
      bordered
      dataSource={users}
      columns={columns}
      pagination={false}
    />
  );
};
